import React from "react";
import "./PildoraMS.css";

const PildoraMS = ({ children, numOfSpecializations, specializations = [], onClick }) => {
  const hasInfo = numOfSpecializations && specializations.length > 0;
  
  const handleClick = (e) => {
    e.preventDefault();
    if (onClick) {
      onClick();
    }
  };
  
  return (
    <div 
      className={`pildoraMS-container ${hasInfo ? 'has-info' : ''}`}
      onClick={handleClick}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          handleClick(e);
        }
      }}
    >
      <p className="pildoraMS">
        <span>{children}</span>
      </p>
      {numOfSpecializations && (
        <div className="pildoraMS-info">
          {/* Estado 1: Mostrar número de especializaciones */}
          <span className="num-specializations">{numOfSpecializations}</span>
          
          {/* Estado 2: Mostrar lista de especializaciones */}
          {specializations.length > 0 && (
            <div className="specializations-list">
              {specializations.map((spec, index) => (
                <span key={index} className="specialization-item">{spec}</span>
              ))}
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default PildoraMS;
